import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { MessageContext } from "../../../../common/message";
import { cleanJoin } from "../../../../utils/stringUtil";
import { PUT } from "../../../../utils/fetchUtil";
import { RequestSubmissionContext } from "../RequestSubmissionContext";
import { useHistory } from "react-router-dom";
import { publish } from "../../../../eventBus";

function Save({ disabled, label, id, uid }) {
  const message = useContext(MessageContext);
  const { state, dispatch } = useContext(RequestSubmissionContext);
  const { t } = useTranslation();
  const history = useHistory();

  const save = () => {
    message.toggle({
      title: t("requests.submission.actions.saveMessageTitle"),
      content: t("requests.submission.actions.saveMessage"),
      onNo: () => message.toggle({}),
      onYes: () => {
        message.toggle({});
        PUT(
          `/requests/${id}/submissions/${uid}`,
          state,
          () => {
            dispatch({ type: "unblock" });
            message.toggle({
              title: t("modalMessage.titleInfo"),
              content: t("requests.submission.actions.saveMessageSuccess"),
              hideNo: true,
              yesLabel: t("modalMessage.okLabel"),
              onYes: () => {
                message.toggle({});
                // history.push(path, state); -> used in MyRequestsPage to scroll to InMaking
                history.push("/requests", "/requests/#t0");
              },
            });
          },
          (error) => {
            message.toggle({
              title: t("requests.overview.supplement.infoBar.errorTitle"),
              content: error,
              hideNo: true,
              yesLabel: t("modalMessage.okLabel"),
              onYes: () => {
                message.toggle({});
              },
            });
          }
        );
      },
    });
  };
  return (
    <button
      disabled={disabled}
      className={cleanJoin(
        "button",
        "pdf-form-action-button",
        "no-focus-outline",
        "has-border-green-1",
        !disabled
          ? "has-background-green-on-hover has-text-white-on-hover has-opacity-71-on-hover"
          : ""
      )}
      onClick={save}
    >
      {label}
    </button>
  );
}

export default Save;
